import global from '@applications/global';

export const userHasIncidentsAccess = () => {
    const IncidentManagmentAppCheck = global.applications['Incident Management'];
    if (IncidentManagmentAppCheck) {
        return true;
    }
    return false;
};
